import { render, staticRenderFns } from "./FasilitasList.vue?vue&type=template&id=7995bc98"
import script from "./FasilitasList.vue?vue&type=script&lang=js"
export * from "./FasilitasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports